/**
 * CardConnect
 *
 * @author markov
 * @returns {CardConnect}
 */

(function(global, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = factory(global);
    }
})(typeof window !== 'undefined' ? window : this, function(window) {
    function    CardConnect(config) {
        this.config = config ? config : {};
    };

    CardConnect.prototype.helperChangeParser = null;
    CardConnect.prototype.useKeySecureDevice = false;
    CardConnect.prototype.useExistingCard = false;
    CardConnect.prototype.apiToken = null;
    CardConnect.prototype.cardConnectTokenizeApiEndpoint = '.cardconnect.com/cardsecure/api/v1/ccn/tokenize';
    CardConnect.prototype.cardConnectVerifyApiEndpoint = '/api/payment-processor/verify?x-api-version=v1';
    CardConnect.prototype.authApiEndpoint = '/client/auth/authorize-current-user?x-api-version=v1';
    CardConnect.prototype.cfTurnstileResponse = null;

    /**
     * Tokenize API
     * @param cardData
     * @param callback
     */
    CardConnect.prototype.initToken = function(cardData, callback) {
        var self = this;

        var expiry = '';
        if(cardData.cc_merchant_expirationyear.length === 2) {
            expiry = cardData.cc_merchant_expirationmonth + cardData.cc_merchant_expirationyear;
        } else {
            expiry = cardData.cc_merchant_expirationyear + cardData.cc_merchant_expirationmonth;
        }

        var data = {
            account: cardData.cc_merchant_cardnumber,
            cvv: cardData.cc_merchant_cvv2Code,
            expiry: expiry,
            unique: false
        };

        var ajaxCallback = function(response) {
            if(response.errorcode === 0){
                self.apiToken = response.token;
                callback(response);
            }else{
                callback({
                    cardConnect_response: 'FAILURE',
                    cardConnect_responsetext: 'Error'
                });
                return false;
            }
        };

        var ajaxOptions = {
            loadingSplash: false,
            type: 'POST',
            contentType: 'application/json',
            callingFrom: 'cardConnect',
            async: false
        };
        var cardConnectSite = jQuery('#gatewaySite').val();
        var endPoint = 'https://'+cardConnectSite+this.cardConnectTokenizeApiEndpoint;
        jQuery.caAjaxApi(endPoint, data, ajaxCallback, ajaxOptions);
    };

    CardConnect.prototype.getAccessToken = function(cardData, callback) {
        var self = this;

        var data = {};
        var ajaxCallback = function(response) {
            if (response.access_token) {
                if (typeof(response.access_token) !== 'undefined') {
                    callback(response);
                } else {
                    callback({
                        cardConnect_response: 'FAILURE',
                        cardConnect_responsetext: 'Error'
                    });
                    return false;
                }
            }
        };

        var ajaxOptions = {
            loadingSplash: false,
            async: false
        };

        jQuery.caAjaxApi(this.authApiEndpoint, data, ajaxCallback, ajaxOptions);
    };

    CardConnect.prototype.verifyCard = function(cardData,access_token, callback) {
        var self = this;

        var expiry = '';
        if(cardData.cc_merchant_expirationyear.length === 2) {
            expiry = cardData.cc_merchant_expirationmonth + cardData.cc_merchant_expirationyear;
        } else {
            expiry = cardData.cc_merchant_expirationyear + cardData.cc_merchant_expirationmonth + '01';
        }
        var currentRetailerId = jQuery('#currentRetailerId').val();
        var data = {
            merchantRetailerId: parseInt(currentRetailerId),
            account: self.apiToken,
            expirationDate:expiry,
            amount: 0,
            captchaResponseToken: this.cfTurnstileResponse,
        };
        if (cardData?.cc_merchant_cvv2Code) {
            data.cvv = cardData.cc_merchant_cvv2Code;
        }

        var ajaxOptions = {
            auth: 'bearer',
            token: access_token,
            loadingSplash: false,
            type: 'POST',
            contentType: 'application/json',
            callingFrom: 'cardConnect',
            async: false
        };

        var ajaxCallback = function(response) {
            callback(response);
            if (response.success === false) {
                callback({
                    cardConnect_response: 'FAILURE',
                    cardConnect_responsetext: response.errors['0'].message
                });
                return false;
            }else if(response.success === true){
                callback({
                    cardConnect_response: 'SUCCESS'
                });
            }
        };

        jQuery.caAjaxApi(this.cardConnectVerifyApiEndpoint, data, ajaxCallback, ajaxOptions);

    };

    /**
     * Get street address from form
     *
     * @param {Array} formParamsArray form params
     * @returns {String}
     */
    CardConnect.prototype.getStreetAddressFromForm = function(formParamsArray) {
        var streetAddress = '';
        var params = {
            state: '',
            city: '',
            address1: '',
            address2: ''
        };
        var associationKeys = {
            'bill_street_address': 'address1',
            'street_address': 'address1',
            'street_address2': 'address2'
        };
        for (var i in formParamsArray) {
            var item = formParamsArray[i];
            if (associationKeys[item.name]) {
                params[associationKeys[item.name]] = item.value;
            }
        }
        for (var j in params) {
            if (!params[j].length) {
                continue;
            }
            if (streetAddress.length) {
                streetAddress += ' ';
            }
            streetAddress += params[j];
        }
        return streetAddress;
    };

    /**
     * @param formParamsArray
     */
    CardConnect.prototype.getCardData = function(formParamsArray) {
        var cardData = {};
        var associationKeys = {
            'cc_number' : 'cc_merchant_cardnumber',
            'card_number' : 'cc_merchant_cardnumber',

            'cc_name' : 'cc_merchant_cardholdername',
            'card_name' : 'cc_merchant_cardholdername',

            'cc_date[month]' : 'cc_merchant_expirationmonth',
            'cc_date[year]' : 'cc_merchant_expirationyear',

            'month' : 'cc_merchant_expirationmonth',
            'year' : 'cc_merchant_expirationyear',

            'bill_cvv' : 'cc_merchant_cvv2Code',
            'cvc' : 'cc_merchant_cvv2Code',
            'security_code' : 'cc_merchant_cvv2Code',

            'bill_zip' : 'cc_merchant_postalcode',
            'zip' : 'cc_merchant_postalcode',
            'post_code' : 'cc_merchant_postalcode',

            // Form user/initial
            'cc_date[m]' : 'cc_merchant_expirationmonth',
            'cc_date[Y]' : 'cc_merchant_expirationyear',

            cc_merchant_p2peblock: 'cc_merchant_p2peblock',
            cc_merchant_account_type: 'cc_merchant_account_type',

            'new_member_form' : 'new_member_form'
        };

        jQuery.each(formParamsArray, function(key, item) {
            if (associationKeys[item.name]) {
                cardData[associationKeys[item.name]] = item.value;
            }
        });

        return cardData;
    };

    /**
     * Validate data card
     *
     * @param cardData
     */
    CardConnect.prototype.validate = function(cardData, success, error) {
        if (!this.useKeySecureDevice) {
            if (cardData.cc_merchant_cardnumber && !cardData.cc_merchant_cvv2Code) {
                error('Please enter credit card CVV');
                return;
            }
        }
        if (cardData.cc_merchant_cardnumber && cardData.cc_merchant_cardnumber.indexOf('*') !== -1) {
            error('For security purposes all changes require the reentry of the credit card number.');
            return;
        }
        success();
    };

    /**
     * @param formParamsArray
     * @param successCallback
     * @param errorCallback
     */
    CardConnect.prototype.dataChange = function(formParamsArray, successCallback, errorCallback) {
        var self = this;
        var cardConnectActive = false;
        for (var i in formParamsArray) {
            var item = formParamsArray[i];
            if (item.name === 'cardconnect_active' && item.value === '1') {
                cardConnectActive = true;
            }

            if (item.name === 'useKeySecureDevice') {
                this.useKeySecureDevice = true;
            }

            if(item.name === 'existingCard' && item.value === '1') {
                this.useExistingCard = true;
            }

            if(item.name === 'isBankAccount' && item.value === '1') {
                successCallback();
                return;
            }

            if(item.name === 'cf-turnstile-response') {
                this.cfTurnstileResponse = item.value;
            }
        }

        if (!cardConnectActive) {
            successCallback();
            return;
        }
        if(this.useExistingCard) {
            successCallback();
            return;
        }

        var cardData = {};
        cardData = this.getCardData(formParamsArray);

        var streetAddress = this.getStreetAddressFromForm(formParamsArray);
        if (streetAddress.length) {
            cardData.cc_merchant_streetaddress = streetAddress;
        }
        if (this.helperChangeParser && !this.helperChangeParser.isChanged()) {
            successCallback();
            return;
        }

        this.validate(
          cardData,
          function() {
              if (!cardData.cc_merchant_cardnumber && !cardData.cc_merchant_p2peblock) {
                  successCallback();
                  return;
              }

              if (cardData.cc_merchant_p2peblock && cardData.cc_merchant_account_type) {
                  self.config['accountType'] = cardData.cc_merchant_account_type;
              }

              self.initToken(cardData, function(data) {
                  if (data && data.cardConnect_response === 'FAILURE') {
                      errorCallback();
                      return;
                  }

                  if (typeof (cardData.new_member_form) === 'undefined' && cardData.new_member_form !== 1) {
                      self.getAccessToken(cardData, function (getAccessTokenResponse) {
                          if (getAccessTokenResponse && getAccessTokenResponse.cardConnect_response === 'FAILURE') {
                              alert('Some error occured');
                              errorCallback();
                              return;
                          }

                          var accessToken = getAccessTokenResponse.access_token;

                          self.verifyCard(cardData, accessToken, function (verifyCardResponse) {
                              if (verifyCardResponse && verifyCardResponse.cardConnect_response === 'FAILURE') {
                                  alert(verifyCardResponse.cardConnect_responsetext);
                                  if (typeof turnstile !== 'undefined') {
                                      turnstile.reset();
                                  }
                                  errorCallback();
                                  return false;
                              } else if (verifyCardResponse && verifyCardResponse.cardConnect_response === 'SUCCESS') {
                                  data.expiration_date = cardData.cc_merchant_expirationyear + '-' + cardData.cc_merchant_expirationmonth + '-01';
                                  data.cc_number = data.token.slice(1, 2) + Array(12).join('*') + data.token.slice(12, 16);
                                  data.cc_merchant_unique_id = data.token;
                                  successCallback(data);
                              }
                          });
                      });
                  } else {
                      data.expiration_date = cardData.cc_merchant_expirationyear + '-' + cardData.cc_merchant_expirationmonth + '-01';
                      data.cc_number = data.token.slice(1, 2) + Array(12).join('*') + data.token.slice(12, 16);
                      data.cc_merchant_unique_id = data.token;
                      successCallback(data);
                  }
              });
          },
          function(error) {
              alert(error);
              errorCallback();
          }
        );
    };

    /**
     * Set CardConnect Params To Form
     *
     * @param $form
     */
    CardConnect.prototype.setCardConnectParamsToForm = function($form, data) {
        var fieldNames = [
            {
                responseName: 'cc_merchant_unique_id',
                inputName: 'cc_merchant_unique_id'
            },
            {
                responseName: 'expiration_date',
                inputName: 'cc_date'
            }
        ];

        jQuery.each(fieldNames, function(key, item) {
            var $item = $form.find('[name="' + item.inputName + '"]');
            if ($item.length) {
                $item.val(data[item.responseName]);
            } else {
                $form.append(
                  '<input type="hidden" name="' + item.inputName + '" value="'
                  + data[item.responseName] + '">'
                );
            }
        });

        $form.find('[name=cc_number],[name="ccInfo[ccNumber]"],[name=card_number]').val(data.cc_number);
    };

    /**
     * Change form for cardConnect
     */
    CardConnect.prototype.formChange = function(form, resultCallback) {
        var self = this;
        jQuery('body').caLoadingSplash();
        jQuery('body').caLoadingSplash('show');
        function callback(result) {
            jQuery('body').caLoadingSplash('hide');
            resultCallback(result);
        }

        var formParamsArray = [];
        if (form) {
            var $form = jQuery(form);
            formParamsArray = helperForm.serializeArray($form);
        }

        this.dataChange(
          formParamsArray,
          function(dataChanged) {
              if (!dataChanged) {
                  callback(true);
                  return;
              }
              var $form = jQuery(form);
              self.setCardConnectParamsToForm( $form, dataChanged);
              callback(true);
          },
          function() {
              callback(false);
          }
        );
    };

    window.CardConnect = CardConnect;

});
